const actionTypes = {
    GET_DEFAULT_RULES_SUCCESS: 'GET_DEFAULT_RULES_SUCCESS',
    GET_APPLICATION_RULE_SUCCESS: 'GET_APPLICATION_RULE_SUCCESS',
    GET_MATCHING_MAPPING_SUCCESS: 'GET_MATCHING_MAPPING_SUCCESS',
    GET_PREDICTED_RULE: 'GET_PREDICTED_RULE',
    GET_LLM_CONFIGS_SUCCESS: 'GET_LLM_CONFIGS_SUCCESS',
};

export default actionTypes;
